var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._l((_vm.searchData),function(product,index){return _c('search-carousel',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedTab === 'products'),expression:"selectedTab === 'products'"}],key:index,attrs:{"product-data":product}})}),(_vm.selectedTab === 'map')?_c('map-index'):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }